import http from '../../services/http-common';
import securityService from '../../components/security/security.service';


class ChequeStatusService {
   
  
  getChequeStatusForList(id, IsChequeCleared) {
      return http.get(`/ChequeStatus/getChequeStatusForList/${securityService.getCompanyIDLoggedInUserId()}/0/2`);
    }

editChequeStatus(data) {
    return http.put(`/ChequeStatus/editChequeStatus`, data);
}

}

export default new ChequeStatusService();